




















































/** @format */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getPayRuleInfo, getPayPlatList, editPayRule } from '@/api/setting-management';
import FormWrap from './form-wrap.vue';
import { DictBizType, dictBizTypeMap, IZhaohangData } from './type';
import Utils from '@root/utils/common';

@Component({
  components: { FormWrap }
})
export default class PayRuleEdit extends Vue {
  private DictBizType = DictBizType;
  private payPlatOption: any[] = [];

  private isDisabled: boolean = true;

  // 初始化数据
  private formList: any[] = [];
  private tempParkingData: any = null;
  private fixedParkingData: any = null;
  private eChargeData: any = null;
  // 编辑后的数据
  private tempParkingEditData: any = null;
  private fixedParkingEditData: any = null;
  private eChargeEditData: any = null;

  // 车场ID
  @Prop({ type: String, default: '' })
  parkId!: string;

  // 对车场ID监听
  @Watch('parkId', { immediate: true })
  onChangeParkId(newVal: string, oldVal: string) {
    this.isDisabled = true;
    this.initData();
  }

  // 重置编辑，数据还原，取消编辑时触发
  async handleResetData() {
    this.isDisabled = true;
    await this.initData();
  }

  // 编辑，提交，表单验证
  async handleEditSubmit(e: any) {
    const tempParkingSwitch = (this.$refs.tempParking as any).getAllowEditSwitch();
    const fixedParkingSwitch = (this.$refs.fixedParking as any).getAllowEditSwitch();
    const eChargeSwitch = (this.$refs.eCharge as any).getAllowEditSwitch();
    this.tempParkingEditData.allowEditSwitch = tempParkingSwitch;
    this.fixedParkingEditData.allowEditSwitch = fixedParkingSwitch;
    this.eChargeEditData.allowEditSwitch = eChargeSwitch;
    try {
      const editPayPlatFormPlateList = [];
      this.tempParkingEditData &&
        editPayPlatFormPlateList.push({
          bizType: '00',
          ...this.tempParkingEditData
        });
      this.fixedParkingEditData &&
        editPayPlatFormPlateList.push({
          bizType: '02',
          ...this.fixedParkingEditData
        });
      this.eChargeEditData && editPayPlatFormPlateList.push({ bizType: '01', ...this.eChargeEditData });
      /**
       * 校验
       */
      const bor = editPayPlatFormPlateList.some((item, index) => {
        if (!item.payType && index === 0) {
          if (tempParkingSwitch == '01') return false;
          this.$message.error('请注意选择临停缴费的支付平台');
          return true;
        }
        if (!item.payType && index === 1) {
          if (fixedParkingSwitch == '01') return false;
          this.$message.error('请注意选择车位固定收费账户的支付平台');
          return true;
        }
        if (!item.payType && index === 2) {
          if (eChargeSwitch == '01') return false;
          this.$message.error('请注意选择电子找零的支付平台');
          return true;
        }
        return false;
      });
      if (bor) return;
      /**
       * 校验
       */
      const borT = editPayPlatFormPlateList
        .map((item, index) => {
          if (item.payType === '00') {
            return item;
          }
        })
        .some((item: any) => {
          if (item && !item.chkAccount) {
            if (item.allowEditSwitch == '01') return false;
            this.$message.error('缺少必填参数,请注意填写对账账号');
            return true;
          }
          if (item && !item.chkPassword) {
            if (item.allowEditSwitch == '01') return false;
            this.$message.error('缺少必填参数,请注意填写对账密钥');
            return true;
          }
          return false;
        });
      if (borT) return;
      const { status, code, msg, data } = await editPayRule({
        parkId: this.parkId,
        editPayPlatFormPlateList
      });
      this.$message.success('保存成功');
      await this.initData();
      this.isDisabled = true;
    } catch (error) {
      console.log(error);
      this.$message.error((error && error.msg) || '保存失败！');
    }
  }
  private keyId = '';
  // 初始化数据
  async initData() {
    const { parkId } = this;
    if (parkId) {
      // 获取编辑详情数据
      try {
        const { parkId } = this;
        const { status, code, msg, data } = await getPayRuleInfo({
          parkId: parkId
        });
        const formList = data;
        if (formList && formList.length > 0) {
          formList.forEach((item: { bizType: DictBizType; allowEditSwitch: boolean }) => {
            // 这里编辑数据进行赋值操作，是为了防止，只点击编辑但不输入内容，没有触发edit数据的更新，最后提交到后台是一个空数组的bug
            if (item.bizType === DictBizType.TempParking) {
              this.tempParkingData = item;
              this.tempParkingData.allowEditSwitch = item.allowEditSwitch || true;
              this.tempParkingEditData = item;
            } else if (item.bizType === DictBizType.FixedParking) {
              this.fixedParkingData = item;
              this.fixedParkingEditData = item;
            } else if (item.bizType === DictBizType.ECharge) {
              this.eChargeData = item;
              this.eChargeEditData = item;
            }
          });
        } else {
          this.reset();
        }
      } catch (e) {
        this.$message.error((e && e.msg) || '获取详情失败！');
      }
    }
  }
  reset() {
    this.formList = [];
    this.tempParkingData = {};
    this.fixedParkingData = {};
    this.eChargeData = {};
    // 编辑后的数据
    this.tempParkingEditData = {};
    this.fixedParkingEditData = {};
    this.eChargeEditData = {};
    this.isDisabled = true;
  }

  // 生命周期初始化
  async created() {
    await this.getPayPlatList();
  }

  async activated() {
    this.isDisabled = true;
    this.initData();
  }

  // 表单数据更新
  tempParkingChange(val: any) {
    this.tempParkingEditData = val;
  }
  fixedParkingChange(val: any) {
    this.fixedParkingEditData = val;
  }
  eChargeChange(val: any) {
    this.eChargeEditData = val;
  }
  /**
   * 监听支付平台选择后不修改数据 payType传入错误的问题
   */
  onChangePayType(options: any, type: any) {
    const { payType } = options;
    switch (type) {
      case 'TempParking':
        this.tempParkingEditData = this.tempParkingEditData
          ? { ...this.tempParkingEditData, payType }
          : { ...this.tempParkingData, payType };
        break;
      case 'FixedParking':
        console.log('1231231231');
        this.fixedParkingEditData = this.fixedParkingEditData
          ? { ...this.fixedParkingEditData, payType }
          : { ...this.fixedParkingData, payType };
        break;
      case 'ECharge':
        this.eChargeEditData = this.eChargeEditData
          ? { ...this.eChargeEditData, payType }
          : { ...this.eChargeData, payType };
        break;
      default:
        break;
    }
  }

  // 获取支付平台下拉数据
  async getPayPlatList() {
    this.payPlatOption = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_base_pay_config_pay_type);
  }
}
